import React from 'react';
import styled from 'styled-components';
import { ErrorMessage } from 'formik';

import { tokens } from '@companycam/slab-tokens';

const StyledInlineErrorMessage = styled.div`
  margin: 6px 0;
  color: ${tokens.color_utility_destroy_le};
  font-size: 13px;
`;

type InputErrorMessageProps = {
  name: string;
};

const InputErrorMessage = ({ name }: InputErrorMessageProps) => (
  <ErrorMessage
    name={name}
    render={(msg) => <StyledInlineErrorMessage>{msg}</StyledInlineErrorMessage>}
  />
);

export default InputErrorMessage;
